import { getCookie } from 'react-use-cookie';

export enum Sprak {
    NO = 'no',
    NN = 'nn',
    EN = 'en',
}

export function hentSprak(): Sprak {
    const sprak = getCookie('ForceLocale1') || 'no';
    switch (sprak) {
        case 'no':
            return Sprak.NO;
        case 'nn':
            return Sprak.NN;
        case 'en':
            return Sprak.EN;
        default:
            return Sprak.NO;
    }
}

export function tilGyldigNetsSprak(sprak: Sprak): string {
    switch (sprak) {
        case Sprak.NN:
        case Sprak.NO:
            return 'nb';
        case Sprak.EN:
            return 'en';
    }
}
